import { render, staticRenderFns } from "./FamCustom.vue?vue&type=template&id=c640bc4e&scoped=true&"
import script from "./FamCustom.vue?vue&type=script&lang=js&"
export * from "./FamCustom.vue?vue&type=script&lang=js&"
import style0 from "./FamCustom.vue?vue&type=style&index=0&id=c640bc4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c640bc4e",
  null
  
)

component.options.__file = "FamCustom.vue"
export default component.exports